<template>
    <div id="edit-letter" class="flex small-padding">
      <div class="styles-panel flex flex-column">
        <Loader class="extra-soft" :soft="true" v-if="softLoading" />
        <h1 class="text-center">Styles</h1>
        <div class="products-wrapper flex flex-column justify-content-center"
           v-for="(category, i) in filterStyles" :key="i">
          <div v-if="category.length"
            class="bold small-margin-top small-margin-bottom">{{ styling_category[i]}}</div>
          <div data-testid="styling-products" class="flex flex-wrap">
            <StyleBox
              v-for="product in category"
              :key="product.variantId"
              :ref="`product-card-${product.variantId}`"
              :outfitArray="outfitArray"
              :numOutfits="numOutfits"
              :singleOutfits="singleOutfits"
              :numButtonOutfits="numButtonOutfits"
              :product="product"
              :onRemove="removeFromBox"
              :onAddFit="clickOutfitButton"
              :onAddSingleFit="clickSingleFit"
              :preshippingFeedback="preshippingFeedback"
              @selectProduct="selectProductInBox"
            />
          </div>
        </div>
      </div>
      <span class="divider"></span>
      <div class="outfits-panel flex flex-column relative font-primary">
        <h1 class="text-center" style="margin-top: 20px;">Outfits</h1>
        <button
            class="btn btn-xl full-width feedbackButtonInLetter"
            @click="showFeedbackSummaryModal"
            >
            FEEDBACK SUMMARY
        </button>

        <div
          data-testid="styling-outfits"
          class="outfits-wrapper flex flex-column small-margin-top"
        >
          <Loader class="extra-soft" :soft="true" v-if="softLoading" />
          <draggable v-model="outfitList" ghost-class="moving-card" class="flex flex-column" @end="onEnd">
            <div
              v-for="(outfit, index) in outfitList"
              class="relative small-margin-bottom"
              :key="index"
            >
              <OutFit
                v-if="outfit.products.length > 0"
                :name="outfit.name"
                :outfit="outfit"
                :preshippingFeedback="preshippingFeedback"
                @onRemove="
                  (productId, variantId) =>
                    removeFromOutfit(
                      Object.keys(outfitArray)[index] > numOutfits
                        ? 0
                        : Object.keys(outfitArray)[index],
                      productId,
                      variantId
                    )
                "
                @addComment="addComment(outfit)"
                @removeOutfit="removeOutfit(outfit.id)"
              />
            </div>
          </draggable>
          <div class="relative small-margin-bottom" v-if="extraOutfit">
            <OutFit
              v-if="extraOutfit.products.length > 0"
              :name="`Extra Clothing`"
              :outfit="extraOutfit"
              :preshippingFeedback="preshippingFeedback"
              @onRemove="
                (productId, variantId) =>
                  removeFromOutfit(0,
                    productId,
                    variantId
                  )
              "
              @addComment="addComment(extraOutfit)"
              @removeOutfit="removeOutfit(0)"
              />
            </div>
        </div>
        <div class="buttons-wrapper flex">
          <button
            data-testid="complete-styling"
            class="btn-sm extremely-small-margin bg-pink"
            @click="completeOutfits"
          >
            View Preview
          </button>
        </div>
      </div>
      <modal name="feedbackSummaryModal" class="feedbackSummaryModalClass stylingProcess" v-if="feedbackSummaryModalShow" @close="feedbackSummaryModalShow = false">
      <div v-click-outside="() => { feedbackSummaryModalShow = false }">
        <FeedbackSummaryModal :summary="feedbackSummary" :survey="survey" :styling="styling" type="customer" />
      </div>
    </modal>
      <modal name="stockWarningModal" v-if="stockWarningModalShow" @close="stockWarningModalShow = false" :modal-width="1000">
        <div v-click-outside="() => { stockWarningModalShow = false }">
          <StockWarningModal :products="stockWarningProductsComputed" @remove="removeProduct" @close="stockWarningModalShow = false" />
        </div>
      </modal>
      <modal name="outfitCommentModal" v-if="commentsModalShow" @close="commentsModalShow = false">
        <div>
          <OutfitCommentModal :comments="selectedComment" :outfit="outfitId" @saveComment="saveOutfitComment" />
        </div>
      </modal>
      <outfit-modal name="outfitsModal" v-if="outfitsModalShow" @close="outfitsModalShow = false" @completeOrder="confirmOutfit" :modal-width="1300">
        <div>
          <CustomerViewModal @close="outfitsModalShow = false" :outfitArray="previewOutfits" />
        </div>
      </outfit-modal>
      <modal name="productModal" v-if="productModalShow" @close="productModalShow = false" :modal-width="1200">
        <div v-click-outside="() => { productModalShow = false }">
          <div class="flex very-small-padding">
            <product-gallery :images="currentProduct.imagesList" />
            <div class="product-info-wrapper flex flex-column border full-width small-margin-left">
              <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>Style Name</span>
                <span>{{ currentProduct.style }}</span>
              </div>
              <div class="flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>Description</span>
                <span style="padding-left: 10px;">{{ currentProduct.description }}</span>
              </div>
              <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>Price</span>
                <span class="text-orange">
                  <span :class="{ 'line-through': currentProduct.price.discount_percentage }">
                    <span class="text-black">
                      {{ currentProduct.price | toCurrency }}
                    </span>
                  </span>
                  &nbsp;
                  <strong v-if="currentProduct.price.discount_percentage">
                    {{ currentProduct.price.sales_price | toCurrency }}
                  </strong>
                </span>
              </div>
              <div class="flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>Fit</span>
                <span></span>
              </div>
              <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>Color</span>
                <span>{{ currentProduct.color.name }}</span>
              </div>
              <div class="flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>Material</span>
                <span>{{ currentProduct.material }}</span>
              </div>
              <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>Product ID</span>
                <span>
                  <router-link :to="{ path: `/product/${currentProduct.id}` }" target="_blank">
                    {{ currentProduct.id }}
                  </router-link>
                </span>
              </div>
              <div class="flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>SKU ID</span>
                <span>{{ currentProduct.sku }}</span>
              </div>
              <div class="border-top border-bottom bg-light-grey flex justify-content-between small-padding-top small-padding-bottom small-padding-right small-padding-left">
                <span>Size</span>
                <span>
                  <select name="size" id="product-size" style="font-size: 15px;" class="uppercase" v-model="currentProduct.variantId">
                    <option v-for="size in currentProduct.variants" :key="size.id" :value="size.id">
                      {{ size.size }}
                    </option>
                  </select>
                </span>
              </div>
              <div class="flex flex-column small-margin-top" v-if="productVote && productVote.counts">
                <div class="very-small-padding-top">
                  <span>Product Size: </span>
                </div>

                <div class="very-small-padding-top very-small-padding-bottom">
                  <button class="small-margin-right" @click="voteProduct('size', 'downsize')">Downsize({{ productVote.counts.size_vote.downsize }})</button>
                  <button class="small-margin-right" @click="voteProduct('size', 'normal')">Normal({{ productVote.counts.size_vote.normal }})</button>
                  <button @click="voteProduct('size', 'upsize')">Upsize({{ productVote.counts.size_vote.upsize }})</button>
                </div>

                <div class="very-small-padding-top">
                  <span>Need to upsize by? </span>
                </div>

                <div class="very-small-padding-top">
                  <span class="small-margin-right">By big bras?</span>
                  <button class="small-margin-right" @click="voteProduct('top', 1)">
                    Yes({{ productVote.counts.upsize_top.yes }})
                  </button>
                  <button @click="voteProduct('top', 0)">
                    No({{ productVote.counts.upsize_top.no }})
                  </button>
                </div>
                <div class="very-small-padding-top">
                  <span class="small-margin-right">By big legs?</span>
                  <button class="small-margin-right" @click="voteProduct('bottom', 1)">
                    Yes({{ productVote.counts.upsize_bottom.yes }})
                  </button>
                  <button @click="voteProduct('bottom', 0)">
                    No({{ productVote.counts.upsize_bottom.no }})
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-content-between small-padding-right small-padding-left">
            <button class="bg-red" @click="productModalShow = false">Close</button>
            <button :class="isCurrentProductIn ? 'bg-red' : 'bg-green'" @click="handleAddRemove" :ref="'button-add-remove-' + currentProduct.id">
              {{ isCurrentProductIn ? 'Remove from Style' : 'Add to Style' }}
            </button>
          </div>
        </div>
      </modal>
    </div>
  </template>

  <script>
  import Vue from 'vue'
  import StyleBox from './StyleBox'
  import OutFit from './Outfit'
  import StockWarningModal from '@/components/styling-process/StockWarningModal.vue'
  import FeedbackSummaryModal from '@/components/styling-process/FeedbackSummaryModal'
  import OutfitCommentModal from '@/components/styling-process/OutfitCommentModal.vue'
  import CustomerViewModal from '@/components/styling-process/CustomerViewModal.vue'
  import ProductGallery from '@/components/ProductGallery.vue'
  import draggable from 'vuedraggable'

  let loader;
  export default {
    name: 'CutLetter',

    components: {
      StyleBox,
      OutFit,
      OutfitCommentModal,
      StockWarningModal,
      FeedbackSummaryModal,
      CustomerViewModal,
      ProductGallery,
      draggable
    },
    props: {
        styling_model_categories: {
            type: Array,
            default: () => []
        },
        feedbackSummary:{
            type: String,
            default: ""
        },
        survey: {
            type: Object,
            default: null
        },
        styling: {
            type: Object,
            default: null
        },
    },
    data () {
      return {
        orderId: null,
        stylingBox: [],
        stylingCategories: [],
        preshippingFeedback: [],
        numOutfits: 3,
        singleOutfits: true,
        outfitArray: {},
        previewOutfits: {},
        softLoading: false,
        stockWarningProducts: [],
        stockWarningModalShow: false,
        commentsModalShow: false,
        outfitsModalShow: false,
        selectedComment: '',
        outfitId: null,
        letterContent: {
          part_1: '',
          part_2: ''
        },
        boxNumber: 1,
        singleStyleComment: '',
        removeCount: 0,
        productModalShow: false,
        currentProduct: null,
        productVote: null,
        feedbackSummaryModalShow: false,
        styling_category: ['BOTTOMS', 'UPPERWEAR', 'OVERWEAR', 'DRESSES', 'ACCESSORIES', 'OTHERS']
      }
    },

    computed: {
      // Main Outfits
      outfitList: {
        get: function () {
          return Object.values(this.outfitArray).filter(outfit => parseInt(outfit.id) !== 0);
        },
        set: function (val) {
          if (this.extraOutfit) {
            const updates = [...Object.values(val), this.extraOutfit]
            this.outfitArray = Object.assign({}, updates)
          } else {
            const updates = [...Object.values(val)]
            this.outfitArray = Object.assign({}, updates)
          }
          this.$forceUpdate()
        }
      },
      // Single Outfit
      extraOutfit: {
        get: function () {
          const outfit = Object.values(this.outfitArray).filter(outfit => parseInt(outfit.id) === 0)
          return outfit.length > 0 ? outfit[0] : undefined
        }
      },
      numButtonOutfits () {
        switch (this.numOutfits) {
          case 3:
          case 2:
            return 3
          case 1:
            return 2
          default:
            return 1
        }
      },
      stockWarningProductsComputed () {
        return this.stylingBox.filter(el => this.stockWarningProducts.includes(el.variantId))
      },
      isCurrentProductIn () {
        return this.stylingBox.findIndex(el => (el.variantId == this.currentProduct.variantId)) >= 0
      },
      // Filter Styles by Category
      filterStyles () {
        const sorted = new Array()
        for (var i = 0; i < 6; i++) {
          sorted[i] = new Array()
        }
        for (const index in this.stylingBox) {
          const category = this.stylingCategories.filter((cate) => cate.product_categories.includes(this.stylingBox[index].category_id))
          if (category.length > 0) {
            switch (category[0].name) {
              case 'Pants':
              case 'Leggings':
              case 'Skirts':
                sorted[0].push(this.stylingBox[index])
                break
              case 'Upperwear':
                sorted[1].push(this.stylingBox[index])
                break
              case 'Overwear':
                sorted[2].push(this.stylingBox[index])
                break
              case 'Dress':
                sorted[3].push(this.stylingBox[index])
                break
              case 'Accessories':
                sorted[4].push(this.stylingBox[index])
                break
              default:
                break
            }
          } else {
            sorted[5].push(this.stylingBox[index])
          }
        }
        return sorted
      }
    },

    methods: {
      onEnd (e) {
        if (e.oldIndex === e.newIndex) {
          return
        }
        const params = this.outfitList.map((outfit, index) => {
          return {
            old: outfit.id,
            new: index + 1
          }
        })
        Vue.api.patch(`/order/${this.$route.query.id}/outfits/sort`,
          { sort_criteria: params },
          {
            before: () => loader = this.$loading.show(),
            always: () => loader.hide(),
            callback: () => {
              this.updateOutfitsView(this.outfitList);
            }
          }
        )
      },
      selectProductInBox (product) {
        this.currentProduct = { ...product, variants: [product.variants] }
        this.selectProduct(product)
      },
      handleAddRemove () {
        this.$refs['button-add-remove-' + this.currentProduct.id].disabled = true
        if (this.isCurrentProductIn) {
          this.removeProduct(this.currentProduct.variantId)
        }
      },
      selectProduct (product) {
        if (!product.variantId) this.selectProperSize(product)

        const slug = product.slug.split('/')[2]
        Vue.api.get(`/product/${product.id}/vote`, {}, {
          before: () => loader = this.$loading.show(),
          always: () => loader.hide(),
          callback: res => {
            this.productVote = res
          }
        })
        Vue.api.get(`/product-slug/${slug}`, {}, {
          callback: res => {
            this.currentProduct.imagesList = res.images
            this.currentProduct.style = res.style
            this.currentProduct.description = res.description
            this.productModalShow = true
          }
        })
      },
      removeProduct (pid) {
        Vue.api.delete(`/styling/order/${this.orderId}/product/${pid}`, {
          styling: 1
        }, {
          before: () => this.softLoading = true,
          always: () => this.softLoading = false,
          callback: res => {
            this.stylingBox.splice(this.stylingBox.findIndex(el => (el.variantId === pid)), 1)
            this.productModalShow = false
          }
        })
      },
      selectProperSize (product) {
        const sizeLabel = this.sizeMapping[product.category_id] || this.sizeMapping[product.subcategory_id]
        const wantedSize = this.customerInfo.sizes[sizeLabel]

        let variantId

        if (wantedSize === undefined) {
          variantId = product.variants[0].id
        } else {
          for (let i = 0; i < product.variants.length; i++) {
            const variant = product.variants[i]
            if (wantedSize >= variant.converted_size_range[0] && wantedSize <= variant.converted_size_range[1]) {
              variantId = variant.id
              break
            }
          }
        }
        this.currentProduct = { ...product, variantId: variantId, imagesList: [] }
      },
      // Add or Update comment of outfits
      saveOutfitComment (outfitId, comment) {
        if (this.outfitArray[outfitId]) {
          this.outfitArray[outfitId].comment = comment
        }
        this.commentsModalShow = false
      },
      // Click Outfit Number
      clickOutfitButton (outfit, product) {
        if (
          this.outfitArray[outfit] &&
          this.outfitArray[outfit].products.findIndex(
            (el) => el.variantId === product.variantId
          ) !== -1
        ) {
          // if the product is already in the outfit
          // then remove it from there
          if (outfit > this.numOutfits) outfit = 0
          this.removeFromOutfit(outfit, product.id, product.variantId)
        } else {
          if (outfit > this.numOutfits) outfit = 0
          if (outfit >= this.numOutfits) {
            this.numOutfits = outfit + 1
          }

          if (this.outfitArray[outfit] && this.outfitArray[outfit].products.findIndex(
            (el) => el.variantId === product.variantId
          ) < 0) {
            const sort_order = this.outfitArray[outfit].products.length + 1
            this.outfitArray[outfit].products = [...this.outfitArray[outfit].products, {
              id: product.id,
              variantId: product.variantId,
              visible: 1,
              sort_order: sort_order,
              subcategory: {
                id: product.subcategory_id,
                name: product.subcategory,
                translation_string_id: product.subcategory_info !== null ? product.subcategory_info.translation_string_id : ""
              },
              thumbnail: product.allImages !== undefined && product.allImages.length > 0 ? product.allImages[0].urls.original : product.images.thumbnail,
              price: product.price
            }]
          } else {
            this.outfitArray[outfit] = {
              id: outfit,
              products: [{
                id: product.id,
                variantId: product.variantId,
                visible: 1,
                sort_order: 1,
                subcategory: {
                  id: product.subcategory_id,
                  name: product.subcategory,
                  translation_string_id: product.subcategory_info !== null ? product.subcategory_info.translation_string_id : ""
                },
                thumbnail: product.allImages !== undefined && product.allImages.length > 0 ? product.allImages[0].urls.original : product.images.thumbnail,
                price: product.price
              }],
              name: outfit === '0' ? 'Extra Clothing' : `Outfit ${outfit}`,
              comment: ''
            }
          }
          this.outfitArray = Object.assign({}, this.outfitArray)
          this.stylingBox.map(style => {
            if (style.variantId === product.variantId) {
              if (style.outfits) {
                if (style.outfits.findIndex((el) => el == outfit) === -1) {
                  style.outfits.push(outfit)
                }
              } else {
                style.outfits = [outfit]
              }
            }
            return style
          })
          this.removeOnExtraOutfits(product)
          this.$forceUpdate()
        }
      },
      // Click "SI" button for Extra Outfit
      clickSingleFit (product) {
        if (
          this.outfitArray[0] &&
          this.outfitArray[0].products.findIndex(
            (el) => el.variantId === product.variantId
          ) !== -1
        ) {
          // if the product is already in the outfit
          // then remove it from there
          this.removeFromOutfit(0, product.id, product.variantId)
        } else {
          if (this.outfitArray[0] && this.outfitArray[0].products.findIndex(
            (el) => el.variantId === product.variantId
          ) < 0) {
            this.outfitArray[0].products = [...this.outfitArray[0].products, {
              id: product.id,
              variantId: product.variantId,
              visible: 1,
              sort_order: this.outfitArray[0].products.length + 1,
              subcategory: {
                id: product.subcategory_id,
                name: product.subcategory,
                translation_string_id: product.subcategory_info !== null ? product.subcategory_info.translation_string_id : ""
              },
              thumbnail: product.allImages !== undefined &&  product.allImages.length > 0 ? product.allImages[0].urls.original : product.images.thumbnail,
              price: product.price
            }]
          } else {
            this.outfitArray[0] = {
              id: 0,
              products: [{
                id: product.id,
                variantId: product.variantId,
                visible: 1,
                sort_order: 1,
                subcategory: {
                  id: product.subcategory_id,
                  name: product.subcategory,
                  translation_string_id: product.subcategory_info !== null ? product.subcategory_info.translation_string_id : ""
                },
                thumbnail: product.allImages !== undefined &&  product.allImages.length > 0 ? product.allImages[0].urls.original : product.images.thumbnail,
                price: product.price
              }],
              name: 'Extra Clothing',
              comment: this.singleStyleComment
            }
          }

          this.outfitArray = Object.assign({}, this.outfitArray)
          this.stylingBox.map(style => {
            if (style.variantId === product.variantId) {
              if (style.outfits) {
                if (style.outfits.findIndex((el) => parseInt(el) == 0) === -1) {
                  style.outfits.push(0)
                }
              } else {
                style.outfits = [0]
              }
            }
            return style
          })
          this.removeOnOtherOutfits(product)
        }
      },
      // Remove product from other Outfits
      removeOnExtraOutfits (product) {
        if (this.outfitArray[0] && this.outfitArray[0].products.findIndex((el) => el.id === product.id) !== -1) {
          this.removeFromOutfit(0, product.id, product.variantId)
        }
      },
      /**
       * see https://app.clickup.com/t/314pwyj
       * Relevant remove products from other when add single
       */
      // Remove product from other Outfits
      removeOnOtherOutfits (product) {
        for (let i = 1; i <= this.numOutfits; i++) {
          if (this.outfitArray[i] && this.outfitArray[i].products.findIndex((el) => el.id === product.id) !== -1) {
            this.removeFromOutfit(i, product.id, product.variantId)
          }
        }
      },
      // Remove Style from Styles of left
      removeFromBox (product) {
        Vue.api.delete(
          `/order/${this.orderId}/product/${product.variantId}`,
          {
            styling: 1
          },
          {
            before: () => (this.softLoading = true),
            always: () => (this.softLoading = false),
            callback: (res) => {
              for (let i = 1; i <= this.numOutfits; i++) {
                if (this.outfitArray[i] && this.outfitArray[i].products.findIndex((el) => el.id === product.id) !== -1) {
                  this.removeFromOutfit(i > this.numOutfits ? 0 : i, product.id, product.variantId)
                }
              }
              if (this.outfitArray[0] && this.outfitArray[0].products.findIndex((el) => el.id === product.id) !== -1) {
                this.removeFromOutfit(0, product.id, product.variantId)
              }
              this.stylingBox.splice(
                this.stylingBox.findIndex((el) => el.variantId == product.variantId),
                1
              )
            }
          }
        )
      },
      // Remove Style from Outfits of right
      removeFromOutfit (outfit, productId, variantId) {
        this.outfitArray[outfit].products = this.outfitArray[outfit].products.filter((el) => el.id !== productId)
        if (this.outfitArray[outfit].products.length === 0) {
          delete this.outfitArray[outfit]
        }
        this.stylingBox.map(style => {
          if (style.variantId === variantId) {
            if (style.outfits) {
              style.outfits.splice(style.outfits.findIndex((el) => el == outfit), 1)
            }
          }
          return style
        })
        this.$forceUpdate()
      },

      updateOutfitsView(outfits) {
        const localOutifts = JSON.parse(JSON.stringify(outfits));
        const nums = Object.keys(localOutifts).length > 0 ? parseInt(Object.keys(this.outfitArray)[Object.keys(this.outfitArray).length - 1]) : 0

        if (nums >= 3) {
            this.numOutfits = nums + 1
        } else {
            this.numOutfits = 3
        }


        const count = this.outfitArray[0] !== null && this.outfitArray[0].name ===  "Extra Clothing" ? nums + 1 : nums;
        for(let i = 0; i <= count; i++){
            if(this.outfitArray[i].name !== "Extra Clothing"){
                delete this.outfitArray[i];
            }
            else{
                if(i !== 0 ){
                    this.outfitArray[0] = this.outfitArray[i];
                    delete this.outfitArray[i];
                }
            }
        }
        for (const outfitIndex in localOutifts) {
            let temp = {}

            const arrIndex = outfitIndex;
            const arr = localOutifts[outfitIndex];
            const products = [];

            arr.products.forEach((prod) => {
                products.push({
                    ...prod,
                    variantId: prod.variantId,
                    visible: prod.visible,
                    sort_order: prod.sort_order
                });


                this.stylingBox.map(style => {
                    if (style.variantId === prod.variantId) {

                        if (style.outfits) {
                            if (style.outfits.findIndex((el) => el == outfitIndex) === -1) {
                                style.outfits.push(outfitIndex)
                            }
                        } else {
                            style.outfits = [outfitIndex]
                        }
                    }
                    return style
                });

                temp = {
                    id: Number(outfitIndex) + 1,
                    products: products.sort((a, b) => a.sort_order < b.sort_order ? -1 : (a.sort_order > b.sort_order ? 1 : 0)),
                    name: `Outfit ${Number(outfitIndex) + 1}`,
                    comment: arr.comment
                }
            });
            const length = Object.keys(this.outfitArray).length;
            let indexValue = this.outfitArray[0] !== undefined && this.outfitArray[0] !== null && this.outfitArray[0].name === "Extra Clothing" ? length : length + 1;
            this.outfitArray[indexValue] =  temp;
            this.$forceUpdate()
        }

        this.$set(this, 'outfitArray', Object.assign({}, this.outfitArray));
      },

      updateOutfits () {
        Vue.api.get(
          `order/${this.orderId}/outfits`,
          {},
          {
            before: () => (this.softLoading = true),
            always: () => (this.softLoading = false),
            callback: (data) => {
              const { outfits, outfit_letter } = data

              const nums = Object.keys(outfits).length > 0 ? parseInt(Object.keys(outfits)[Object.keys(outfits).length - 1]) : 0
              if (nums >= 3) {
                this.numOutfits = nums + 1
              } else {
                this.numOutfits = 3
              }
              this.resetOutfitArray()
              const temp = {}

              for (const outfitIndex in outfits) {
                if (outfitIndex == 0) {
                  this.singleOutfits = true
                }
                const arrIndex = outfitIndex
                const arr = outfits[outfitIndex]
                const products = []
                for (const key in arr) {
                  if (key !== 'selected_tips' && key !== 'custom_outfit_text') {
                    products.push({
                      ...arr[key].product,
                      variantId: arr[key].variant ? arr[key].variant.id : arr[key].product.id,
                      visible: arr[key].visible,
                      sort_order: arr[key].sort_order
                    })
                    this.stylingBox.map(style => {
                      if (style.variantId === arr[key].variant.id) {
                        if (style.outfits) {
                          if (style.outfits.findIndex((el) => el == outfitIndex) === -1) {
                            style.outfits.push(outfitIndex)
                          }
                        } else {
                          style.outfits = [outfitIndex]
                        }
                      }
                      return style
                    })
                  }
                }
                var outfit_comment = ''
                const selectOutfit = Object.values(outfit_letter).filter(letter => letter.outfit === parseInt(outfitIndex))
                if (selectOutfit.length > 0) {
                  outfit_comment = selectOutfit[0].stylist_comment
                }
                temp[arrIndex] = {
                  id: outfitIndex,
                  products: products.sort((a, b) => a.sort_order < b.sort_order ? -1 : (a.sort_order > b.sort_order ? 1 : 0)),
                  name: outfitIndex === '0' ? 'Extra Clothing' : `Outfit ${outfitIndex}`,
                  comment: outfit_comment
                }
              }
              this.outfitArray = Object.assign({}, temp)
              this.$forceUpdate()
            }
          }
        )
      },

      resetOutfitArray () {
        for (let i = 1; i <= this.numOutfits; i++) {
          this.outfitArray[i] = {
            products: []
          }
        }
      },
      addComment (outfit) {
        this.selectedComment = outfit.comment
        this.outfitId = parseInt(outfit.id)
        setTimeout(() => {
          this.commentsModalShow = true
        }, 100)
      },
      closeCommentModal () {
        this.commentsModalShow = false
        this.updateOutfits()
      },

      removeOutfit (outfit) {
        if(Number(outfit) === 0){
            if(this.outfitArray[outfit] !== null){
                delete this.outfitArray[outfit];
            }
        }
        else{
            const arrayLength = Object.keys(this.outfitArray).length;
            delete this.outfitArray[outfit];

            for(let i = Number(outfit); i < arrayLength; i++){
                if(this.outfitArray[i + 1] !== null){
                    if(this.outfitArray[i + 1] === undefined){
                        delete this.outfitArray[i + 1];
                    }
                    else{
                        this.outfitArray[i] = this.outfitArray[i + 1];
                        this.outfitArray[i].id = i;
                        this.outfitArray[i].name = `Outfit ${i}`;

                        delete this.outfitArray[i + 1];
                    }
                }
            }
        }
        this.$set(this, 'outfitArray', Object.assign({}, this.outfitArray));
      },

      addOutfit () {
        if (this.numOutfits < 50) {
          this.numOutfits = this.numOutfits + 1
        }
      },

      addSingleStyle () {
        this.singleOutfits = true
      },
      confirmOutfit () {
        this.outfitsModalShow = false
        this.$emit('closePanel', { confirm: true })
      },
      /**
       * @see https://app.clickup.com/t/865d1za7t
       * Relevant bulk update outfits
       * Need to implement new endpoint.
       */
      updateProductsWithOutfit () {
        return new Promise((resolve, reject) => {
          var products = []
          Object.values(this.outfitArray).forEach((outfit) => {
            outfit.products.forEach((item) => {
              const product = {
                outfit: parseInt(outfit.id),
                product_id: item.id,
                variant_id: item.variantId,
                sort_order: item.sort_order,
                visible: item.visible
              }
              products.push(product)
            })
          })

          var comments = []
          Object.values(this.outfitArray).forEach((outfit) => {
            const comment = {
              outfit: parseInt(outfit.id),
              stylist_comment: outfit.comment
            }
            comments.push(comment)
          })
          Vue.api.post(`/order/${this.orderId}/outfits/update`, {
            products,
            comments
          }, {
            before: () => (this.softLoading = true),
            always: () => (this.softLoading = false),
            callback: () => {
              resolve(true)
            },
            error: (err) => {
              loader.hide()
              reject(err.data.message)
            }
          })
        })
      },
      /**
       * @see https://app.clickup.com/t/2w4bxeq
       * Relevant for fix outfits preview
       */
      completeOutfits () {
        const checkOutfit = Object.values(this.stylingBox).filter(style => style.outfits === undefined || (style.outfits && style.outfits.length === 0))
        if (checkOutfit.length > 0) {
          alert('Some styles have not been assigned to any outfits or Extra Clothing.')
        } else {
          this.updateProductsWithOutfit().then(res => {
            var outfitNums = []; var missed = []
            this.previewOutfits = Object.values(this.outfitArray).map((outfit, index) => {
              var size = 1
              const products = outfit.products
              if (products.length > 5) {
                size = products.length / 5
                if (products.length % 3 === 0) {
                  size = products.length / 3
                }
                if (products.length % 4 === 0) {
                  size = products.length / 4
                }
                if (products.length % 5 === 0) {
                  size = products.length / 5
                }
              }
              const prods = this.splitArray(products, size)
              outfitNums.push(parseInt(outfit.id))
              return {
                id: outfit.id,
                name: outfit.name,
                comment: outfit.comment,
                productsRow: prods.sort((a, b) => a.sort_order < b.sort_order ? -1 : (a.sort_order > b.sort_order ? 1 : 0))
              }
            })

            for (var i = 1; i <= this.numOutfits; i++) {
              if (outfitNums.indexOf(i) == -1) {
                missed.push(i)
              }
            }
            loader = this.$loading.show()
            this.showPreviewOutfits()
          // this.removeEmptyOutfit(missed.sort())
          })
        }
      },
      showPreviewOutfits () {
        this.lastOutfits().then(outfitArray => {
          this.previewOutfits = Object.values(outfitArray).map((outfit, index) => {
            var size = 1
            const products = outfit.products
            if (products.length > 5) {
              size = products.length / 5
              if (products.length % 3 === 0) {
                size = products.length / 3
              }
              if (products.length % 4 === 0) {
                size = products.length / 4
              }
              if (products.length % 5 === 0) {
                size = products.length / 5
              }
            }
            const prods = this.splitArray(products, size)
            return {
              id: outfit.id,
              name: outfit.name,
              comment: outfit.comment,
              productsRow: prods.sort((a, b) => a.sort_order < b.sort_order ? -1 : (a.sort_order > b.sort_order ? 1 : 0))
            }
          })
          loader.hide()
          if (Object.values(this.previewOutfits).length > 0) {
            this.outfitsModalShow = true
          }
        })
      },

      /**
       * @see https://app.clickup.com/t/2w4bxcz
       * Relevant for skip an outfit number
       * Need to remove empty Outfit. e.g: if stylist added the outfit1 and outfit3, so she missed outfit2. we need to move outfit3 to outfit2 when preview the outfits.
       * It was implemented when we use APIs on each interaction. I think we don't need any more.
       */
      removeEmptyOutfit (outfits) {
        if (outfits.length > 0) {
          this.removeRequest(outfits[0] - this.removeCount).then(res => {
            const _ = outfits.shift()
            this.removeCount = this.removeCount + 1
            this.removeEmptyOutfit(outfits)
          })
        } else {
          this.removeCount = 0
          this.lastOutfits().then(outfitArray => {
            this.previewOutfits = Object.values(outfitArray).map((outfit, index) => {
              var size = 1
              const products = outfit.products
              if (products.length > 5) {
                size = products.length / 5
                if (products.length % 3 === 0) {
                  size = products.length / 3
                }
                if (products.length % 4 === 0) {
                  size = products.length / 4
                }
                if (products.length % 5 === 0) {
                  size = products.length / 5
                }
              }
              const prods = this.splitArray(products, size)
              return {
                id: outfit.id,
                name: outfit.name,
                comment: outfit.comment,
                productsRow: prods.sort((a, b) => a.sort_order < b.sort_order ? -1 : (a.sort_order > b.sort_order ? 1 : 0))
              }
            })
            loader.hide()
            if (Object.values(this.previewOutfits).length > 0) {
              this.outfitsModalShow = true
            }
          })
        }
      },
      removeRequest (outfit) {
        return new Promise((resolve, reject) => {
          Vue.api.delete(`/order/${this.orderId}/outfit/${outfit}`, {}, {
            before: () => (this.softLoading = true),
            always: () => (this.softLoading = false),
            callback: () => {
              if (outfit == 0) {
                this.singleOutfits = false
              } else {
                this.numOutfits = this.numOutfits - 1
              }
              resolve(true)
            },
            error: (err) => {
              loader.hide()
              reject(err.data.message)
            }
          })
        })
      },
      lastOutfits () {
        return new Promise((resolve, reject) => {
          Vue.api.get(`order/${this.orderId}/outfits`, {}, {
            before: () => (this.softLoading = true),
            always: () => (this.softLoading = false),
            callback: (data) => {
              const { outfits, outfit_letter } = data

              const temp = {}

              for (const outfitIndex in outfits) {
                if (outfitIndex == 0) {
                  this.singleOutfits = true
                }
                const arrIndex =
                  outfitIndex != 0 ? outfitIndex : this.numOutfits + 1
                const arr = outfits[outfitIndex]
                const products = []
                for (const key in arr) {
                  if (key !== 'selected_tips' && key !== 'custom_outfit_text') {
                    products.push({
                      ...arr[key].product,
                      variantId: arr[key].variant ? arr[key].variant.id : arr[key].product.id,
                      visible: arr[key].visible,
                      sort_order: arr[key].sort_order
                    })
                    this.stylingBox.map(style => {
                      if (style.variantId === arr[key].variant.id) {
                        if (style.outfits) {
                          if (style.outfits.findIndex((el) => el == outfitIndex) === -1) {
                            style.outfits.push(outfitIndex)
                          }
                        } else {
                          style.outfits = [outfitIndex]
                        }
                      }
                      return style
                    })
                  }
                }
                var outfit_comment = ''
                const selectOutfit = Object.values(outfit_letter).filter(letter => letter.outfit === parseInt(outfitIndex))
                if (selectOutfit.length > 0) {
                  outfit_comment = selectOutfit[0].stylist_comment
                }
                temp[arrIndex] = {
                  id: outfitIndex,
                  products: products.sort((a, b) => a.sort_order < b.sort_order ? -1 : (a.sort_order > b.sort_order ? 1 : 0)),
                  name: outfitIndex === '0' ? 'Extra Clothing' : `Outfit ${outfitIndex}`,
                  comment: outfit_comment
                }
              }
              const outfitArray = Object.assign({}, temp)
              resolve(outfitArray)
            },
            error: (err) => {
              loader.hide()
              reject(err.data.message)
            }
          })
        })
      },
      splitArray (arr, rows) {
        const itemsPerRow = Math.ceil(arr.length / rows)
        return arr.reduce((acc, val, ind) => {
          const currentRow = Math.floor(ind / itemsPerRow)
          if (!acc[currentRow]) {
            acc[currentRow] = [val]
          } else {
            acc[currentRow].push(val)
          }
          return acc
        }, [])
      },
      
      showFeedbackSummaryModal () {
        loader = this.$loading.show()
        setTimeout(() => {
            loader.hide()
            this.feedbackSummaryModalShow = true
        }, 100)
        },
        
      showStockWarningModal (data) {
        loader = this.$loading.show()
        setTimeout(() => {
          loader.hide()
          this.stockWarningProducts = data
          this.stockWarningModalShow = true
        }, 100)
      },
    },

    created () {
      this.orderId = this.$route.query.id;
      this.stylingBox = this.$store.state.stylingBox;
      this.stylingCategories = this.$store.state.stylingProductCategories;
      this.preshippingFeedback = this.$store.state.preshippingStylingFeedback;
      this.boxNumber = this.$store.state.letterText.stylingBoxNumber;
      this.singleStyleComment = this.$store.state.letterText.stylingSingleComment;

      this.resetOutfitArray()

        Vue.api.get(
            `order/${this.orderId}/outfits`,
            {},
            {
                callback: (data) => {
                    const { outfits, outfit_letter, letter_text } = data
                    this.letterContent = letter_text
                    const nums = Object.keys(outfits).length > 0 ? parseInt(Object.keys(outfits)[Object.keys(outfits).length - 1]) : 0
                    if (nums >= 3) {
                    this.numOutfits = nums + 1
                    } else {
                    this.numOutfits = 3
                    }

                    this.resetOutfitArray()
                    const temp = {}

                    for (const outfitIndex in outfits) {
                    if (outfitIndex == 0) {
                        this.singleOutfits = true
                    }
                    const arrIndex = outfitIndex

                    const arr = outfits[outfitIndex]
                    const products = []
                    for (const key in arr) {
                        if (key !== 'selected_tips' && key !== 'custom_outfit_text') {
                        products.push({
                            ...arr[key].product,
                            variantId: arr[key].variant ? arr[key].variant.id : arr[key].product.id,
                            visible: arr[key].visible,
                            sort_order: arr[key].sort_order
                        })
                        this.stylingBox.map(style => {
                            if (style.variantId === arr[key].variant.id) {
                            if (style.outfits) {
                                style.outfits.push(outfitIndex)
                            } else {
                                style.outfits = [outfitIndex]
                            }
                            }
                            return style
                        })
                        }
                    }
                    var outfit_comment = ''
                    const selectOutfit = Object.values(outfit_letter).filter(letter => letter.outfit === parseInt(outfitIndex))
                    if (selectOutfit.length > 0) {
                        outfit_comment = selectOutfit[0].stylist_comment
                    }
                    temp[arrIndex] = {
                        id: outfitIndex,
                        products: products.sort((a, b) => a.sort_order < b.sort_order ? -1 : (a.sort_order > b.sort_order ? 1 : 0)),
                        name: outfitIndex === '0' ? 'Extra Clothing' : `Outfit ${outfitIndex}`,
                        comment: outfit_comment
                    }
                    }
                    this.outfitArray = Object.assign({}, temp)

                    this.$forceUpdate();
                }
            }
        )
    },
    beforeDestroy(){
        this.updateProductsWithOutfit();
    }
  }
  </script>

  <style lang="less" scoped>
  @import "../../../styles/variables.less";

  .moving-card {
    opacity: 0.5;
    background: #F7FAFC;
    border: 1px solid #4299e1;
  }

  * {
    box-sizing: border-box;
  }

  #edit-letter {
    position: relative;
    padding-top: 80px;
  }

  .extremely-small-margin {
    margin: 2px;
  }

  .buttons-wrapper {
    display: flex;
    justify-content: right;
    button {
      border: 1px solid #888;
    }
  }

  .hover-effect:hover {
    transform: scale(1.1);
  }

  .num-outfits {
    position: absolute;
    top: 20px;
    right: 30px;
  }

  .styles-panel {
    position: relative;
    width: 45%;
    padding-right: 50px;
    padding-left: 50px;

    h1 {
      margin-bottom: 0;
    }

    p {
      margin: 5px 0 20px;
      font-family: Arial, Helvetica, sans-serif;
      color: #535353;
    }
  }

  .divider {
    width: 0;
    border: 1px solid #000;
    margin-top: 80px;
  }

  .product-image {
    border: 1px solid #000;
    width: 100%;
    height: 180px;
    // padding: 10px;
    object-fit: contain;
  }
  .btn-remove,
  .btn-hide {
    position: absolute;
    top: 0;
    left: 0;
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    background: #000;
    color: #fff;
    font-weight: 900;

    &:hover {
      background-color: #fff;
      color: #000;
      border: 1px solid #000;
    }
  }

  .outfits-panel {
    width: 55%;
    padding: 0 50px;
    font-family: @font-primary;
  }

  .loader.extra-soft {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  </style>

  <style lang="less">
  .smooth-enter-active,
  .smooth-leave-active {
    transition: opacity 0.5s;
  }
  .smooth-enter,
  .smooth-leave-to {
    opacity: 0;
  }

  .feedbackButtonInLetter{
    position: absolute;
    width: fit-content;
    top: 20px;
    right: 10px;
    margin: 0;
    background: #d59f28;
    font-size: 12px;
    padding: 9px 40px;


    @media screen and (max-width: 1400px) {
        padding: 9px 25px;
    }
  }
  </style>
